<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>
            {{ $t("menu.applicant_info_eng_inter") }}
          </v-card-title>
          <v-divider color="white"></v-divider>
          <div class="title1">
            {{ $t("applicantInfo_medical.educational_background") }}
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="diplomaType"
                v-bind:label="
                  $t('applicantInfo_medical.educational_background')
                "
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="diplomaType_group"
                v-bind:item-value="(item) => item.diplomaType_value"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- AP/IB/IGCSE -->
          <div
            v-show="
              this.diplomaType === 'IB DP' ||
              this.diplomaType === 'IGCSE/GCSE/GCE'
            "
          >
            <div class="title1">
              {{ $t("applicantInfo_engInter.AP_IB_IGCSE_test_score") }}
            </div>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_1_name"
                  v-bind:label="$t('applicantInfo_engInter.subject_1_name')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_1_name')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_1_score"
                  v-bind:label="$t('applicantInfo_engInter.subject_1_score')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_1_score')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <DateSelectCard
                  v-model="subject_1_testDate"
                  v-bind:label="$t('applicantInfo_medical.test_date')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_2_name"
                  v-bind:label="$t('applicantInfo_engInter.subject_2_name')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_2_name')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_2_score"
                  v-bind:label="$t('applicantInfo_engInter.subject_2_score')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_2_score')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <DateSelectCard
                  v-model="subject_2_testDate"
                  v-bind:label="$t('applicantInfo_medical.test_date')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_3_name"
                  v-bind:label="$t('applicantInfo_engInter.subject_3_name')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_3_name')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="subject_3_score"
                  v-bind:label="$t('applicantInfo_engInter.subject_3_score')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.subject_3_score')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <DateSelectCard
                  v-model="subject_3_testDate"
                  v-bind:label="$t('applicantInfo_medical.test_date')"
                />
              </v-col>
            </v-row>
          </div>
          <!-- GED -->
          <div v-show="this.diplomaType === 'GED'">
            <div class="title1">
              {{ $t("applicantInfo_engInter.GED") }}
            </div>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="GED_RTLA_score"
                  v-bind:label="$t('applicantInfo_engInter.GED_RTLA_score')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.GED_RTLA_score')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="GED_MR_score"
                  v-bind:label="$t('applicantInfo_engInter.GED_MR_score')"
                  v-bind:placeholder="$t('applicantInfo_engInter.GED_MR_score')"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="GED_SCI_score"
                  v-bind:label="$t('applicantInfo_engInter.GED_SCI_score')"
                  v-bind:placeholder="
                    $t('applicantInfo_engInter.GED_SCI_score')
                  "
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="GED_SS_score"
                  v-bind:label="$t('applicantInfo_engInter.GED_SS_score')"
                  v-bind:placeholder="$t('applicantInfo_engInter.GED_SS_score')"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <DateSelectCard
                  v-model="GED_testDate"
                  v-bind:label="$t('applicantInfo_medical.test_date')"
                />
              </v-col>
            </v-row>
          </div>
          <div class="title1">
            {{ $t("applicantInfo_medical.standard_academic_test") }}
          </div>
          <!-- SAT 1-->
          <div class="title2">
            {{ $t("applicantInfo_medical.SAT1_subject_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT1_math_score"
                v-bind:label="$t('applicantInfo_medical.mathematics')"
                v-bind:placeholder="$t('applicantInfo_medical.mathematics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT1_readingWriting_score"
                v-bind:label="$t('applicantInfo_medical.reading_writing')"
                v-bind:placeholder="$t('applicantInfo_medical.reading_writing')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT1_total_score"
                v-bind:label="$t('applicantInfo_medical.total')"
                v-bind:placeholder="$t('applicantInfo_medical.total')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="SAT1_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!--OLD SAT -->
          <div class="title2">
            {{ $t("applicantInfo_medical.OldSAT_subject_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="OLD_SAT_math"
                v-bind:label="$t('applicantInfo_medical.verbal')"
                v-bind:placeholder="$t('applicantInfo_medical.verbal')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="OLD_SAT_verbal"
                v-bind:label="$t('applicantInfo_medical.mathematics')"
                v-bind:placeholder="$t('applicantInfo_medical.mathematics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="OLD_SAT_writing"
                v-bind:label="$t('applicantInfo_medical.writing')"
                v-bind:placeholder="$t('applicantInfo_medical.writing')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="OLD_SAT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- SAT  2-->
          <div class="title2">
            {{ $t("applicantInfo_medical.SAT2_subject_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_biology"
                v-bind:label="$t('applicantInfo_medical.biology')"
                v-bind:placeholder="$t('applicantInfo_medical.biology')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_chemistry"
                v-bind:label="$t('applicantInfo_medical.chemistry')"
                v-bind:placeholder="$t('applicantInfo_medical.chemistry')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_physics"
                v-bind:label="$t('applicantInfo_medical.physics')"
                v-bind:placeholder="$t('applicantInfo_medical.physics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_math"
                v-bind:label="$t('applicantInfo_medical.mathematics')"
                v-bind:placeholder="$t('applicantInfo_medical.mathematics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="SAT2_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- ACT -->
          <div class="title2">ACT</div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="ACT_score"
                label="ACT"
                placeholder="ACT"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="ACT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- IB -->
          <div class="title2">IB</div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="IB_score"
                label="IB"
                placeholder="IB"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="IB_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- GAT -->
          <div class="title2">GAT</div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="GAT1_score"
                label="GAT 1"
                placeholder="GAT 1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="GAT2_score"
                label="GAT 2"
                placeholder="GAT 2"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="GAT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- PAT -->
          <div class="title2">PAT</div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="PAT1_score"
                label="PAT 1"
                placeholder="PAT 1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="PAT3_score"
                label="PAT 3"
                placeholder="PAT 3"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="PAT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- ผลการสอบวัดความสามารถในการสื่อสารภาษาอังกฤษ -->
          <div class="title1">
            {{ $t("applicantInfo_medical.english_proficiency_test") }}
          </div>
          <!-- TOEFL -->
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="TOEFL_score"
                label="TOEFL"
                placeholder="TOEFL"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="TOEFL_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- IELTS -->
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="IELTS_score"
                label="IELTS"
                placeholder="IELTS"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="IELTS_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- KMITL TEP -->
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="KMITL_TEP_score"
                label="KMITL TEP"
                placeholder="KMITL TEP"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="KMITL_TEP_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <!-- Other -->
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="OTHER_name"
                label="Other name"
                placeholder="Other name"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="OTHER_score"
                label="Other score"
                placeholder="Other score"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="OTHER_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import DateSelectCard from "@/components/info_cards/DateSelect";
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ApplicantInfoEngInter",
  data: function () {
    return {
      loading: false,
      form_validate_status: null,

      diplomaType_group: [
        {
          diplomaType_value: "Matthayom 6",
          name_TH: "Secondary School (Matthayom 6)",
          name_EN: "Secondary School (Matthayom 6)",
        },
        {
          diplomaType_value: "Grade 12",
          name_TH: "High School Diploma (Grade 12)",
          name_EN: "High School Diploma (Grade 12)",
        },
        {
          diplomaType_value: "IB DP",
          name_TH: "International Baccalaureate (IB DP)",
          name_EN: "International Baccalaureate (IB DP)",
        },
        {
          diplomaType_value: "IGCSE/GCSE/GCE",
          name_TH: "IGCSE/GCSE/GCE",
          name_EN: "IGCSE/GCSE/GCE",
        },
        {
          diplomaType_value: "GED",
          name_TH: "High School Equivalent (GED)",
          name_EN: "High School Equivalent (GED)",
        },
      ],

      totalWord: null,

      diplomaType: null,
      subject_1_name: null,
      subject_1_score: null,
      subject_1_testDate: null,
      subject_2_name: null,
      subject_2_score: null,
      subject_2_testDate: null,
      subject_3_name: null,
      subject_3_score: null,
      subject_3_testDate: null,
      GED_RTLA_score: null,
      GED_MR_score: null,
      GED_SCI_score: null,
      GED_SS_score: null,
      GED_testDate: null,

      SAT1_math_score: null,
      SAT1_readingWriting_score: null,
      SAT1_total_score: null,
      SAT1_testDate: null,

      OLD_SAT_verbal: null,
      OLD_SAT_math: null,
      OLD_SAT_writing: null,
      OLD_SAT_testDate: null,

      ACT_score: null,
      ACT_testDate: null,
      IB_score: null,
      IB_testDate: null,
      GAT1_score: null,
      GAT2_score: null,
      GAT_testDate: null,
      PAT1_score: null,
      PAT3_score: null,
      PAT_testDate: null,

      SAT2_biology: null,
      SAT2_chemistry: null,
      SAT2_physics: null,
      SAT2_math: null,
      SAT2_testDate: null,

      TOEFL_score: null,
      TOEFL_testDate: null,
      IELTS_score: null,
      IELTS_testDate: null,
      KMITL_TEP_score: null,
      KMITL_TEP_testDate: null,
      OTHER_name: null,
      OTHER_score: null,
      OTHER_testDate: null,

      // personalStatement: null,
    };
  },
  components: { DateSelectCard },

  methods: {
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const data = await applicantInfoService.getApplicantInfoEngInter(uid);

      this.diplomaType = data.DIPLOMA_TYPE;
      this.subject_1_name = data.SUBJECT_1_NAME;
      this.subject_1_score = data.SUBJECT_1_SCORE;
      this.subject_1_testDate = data.SUBJECT_1_TEST_DATE;
      this.subject_2_name = data.SUBJECT_2_NAME;
      this.subject_2_score = data.SUBJECT_2_SCORE;
      this.subject_2_testDate = data.SUBJECT_2_TEST_DATE;
      this.subject_3_name = data.SUBJECT_3_NAME;
      this.subject_3_score = data.SUBJECT_3_SCORE;
      this.subject_3_testDate = data.SUBJECT_3_TEST_DATE;

      this.GED_RTLA_score =
        data.GED_RTLA_SCORE === "0" ? "" : data.GED_RTLA_SCORE;
      this.GED_MR_score = data.GED_MR_SCORE === "0" ? "" : data.GED_MR_SCORE;
      this.GED_SCI_score = data.GED_SCI_SCORE === "0" ? "" : data.GED_SCI_SCORE;
      this.GED_SS_score = data.GED_SS_SCORE === "0" ? "" : data.GED_SS_SCORE;
      this.GED_testDate = data.GED_TEST_DATE;

      this.SAT1_math_score =
        data.SAT_1_MATH_SCORE === "0" ? "" : data.SAT_1_MATH_SCORE;
      this.SAT1_readingWriting_score =
        data.SAT_1_RW_SCORE === "0" ? "" : data.SAT_1_RW_SCORE;
      this.SAT1_total_score =
        data.SAT_1_TOTAL_SCORE === "0" ? "" : data.SAT_1_TOTAL_SCORE;
      this.SAT1_testDate =
        data.SAT_1_TEST_DATE === "0" ? "" : data.SAT_1_TEST_DATE;

      this.OLD_SAT_verbal =
        data.OLD_SAT_VERBAL_SCORE === "0" ? "" : data.OLD_SAT_VERBAL_SCORE;
      this.OLD_SAT_math =
        data.OLD_SAT_MATH_SCORE === "0" ? "" : data.OLD_SAT_MATH_SCORE;
      this.OLD_SAT_writing =
        data.OLD_SAT_WRITING_SCORE === "0" ? "" : data.OLD_SAT_WRITING_SCORE;
      this.OLD_SAT_testDate = data.OLD_SAT_TEST_DATE;

      this.SAT2_biology =
        data.SAT_2_BIO_SCORE === "0" ? "" : data.SAT_2_BIO_SCORE;
      this.SAT2_chemistry =
        data.SAT_2_CHEM_SCORE === "0" ? "" : data.SAT_2_CHEM_SCORE;
      this.SAT2_physics =
        data.SAT_2_PHY_SCORE === "0" ? "" : data.SAT_2_PHY_SCORE;
      this.SAT2_math =
        data.SAT_2_MATH_SCORE === "0" ? "" : data.SAT_2_MATH_SCORE;
      this.SAT2_testDate = data.SAT_2_TEST_DATE;

      this.ACT_score = data.ACT_SCORE === "0" ? "" : data.ACT_SCORE;
      this.ACT_testDate = data.ACT_TEST_DATE;
      this.IB_score = data.IB_SCORE === "0" ? "" : data.IB_SCORE;
      this.IB_testDate = data.IB_TEST_DATE;

      this.GAT1_score = data.GAT_1_SCORE === "0" ? "" : data.GAT_1_SCORE;
      this.GAT2_score = data.GAT_2_SCORE === "0" ? "" : data.GAT_2_SCORE;
      this.GAT_testDate = data.GAT_TEST_DATE;
      this.PAT1_score = data.PAT_1_SCORE === "0" ? "" : data.PAT_1_SCORE;
      this.PAT3_score = data.PAT_3_SCORE === "0" ? "" : data.PAT_3_SCORE;
      this.PAT_testDate = data.PAT_TEST_DATE;

      this.TOEFL_score = data.TOFEL_SCORE === "0" ? "" : data.TOFEL_SCORE;
      this.TOEFL_testDate = data.TOFEL_TEST_DATE;
      this.IELTS_score = data.IELTS_SCORE === "0" ? "" : data.IELTS_SCORE;
      this.IELTS_testDate = data.IELTS_TEST_DATE;
      this.KMITL_TEP_score =
        data.KMITL_TEP_SCORE === "0" ? "" : data.KMITL_TEP_SCORE;
      this.KMITL_TEP_testDate = data.KMITL_TEP_TEST_DATE;
      this.OTHER_name = data.OTHER_NAME;
      this.OTHER_score = data.OTHER_SCORE === "0" ? "" : data.OTHER_SCORE;
      this.OTHER_testDate = data.OTHER_TEST_DATE;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      const uid = localStorage.getItem("uid");
      const response = await applicantInfoService
        .setApplicantInfoEngInter(
          {
            DIPLOMA_TYPE: this.diplomaType !== "" ? this.diplomaType : null,
            SUBJECT_1_NAME:
              this.subject_1_name !== "" ? this.subject_1_name : null,
            SUBJECT_1_SCORE:
              this.subject_1_score !== "" ? this.subject_1_score : null,
            SUBJECT_1_TEST_DATE:
              this.subject_1_testDate !== "" ? this.subject_1_testDate : null,
            SUBJECT_2_NAME:
              this.subject_2_name !== "" ? this.subject_2_name : null,
            SUBJECT_2_SCORE:
              this.subject_2_score !== "" ? this.subject_2_score : null,
            SUBJECT_2_TEST_DATE:
              this.subject_2_testDate !== "" ? this.subject_2_testDate : null,
            SUBJECT_3_NAME:
              this.subject_3_name !== "" ? this.subject_3_name : null,
            SUBJECT_3_SCORE:
              this.subject_3_score !== "" ? this.subject_3_score : null,
            SUBJECT_3_TEST_DATE:
              this.subject_3_testDate !== "" ? this.subject_3_testDate : null,

            GED_RTLA_SCORE:
              this.GED_RTLA_score !== "" ? this.GED_RTLA_score : null,
            GED_MR_SCORE: this.GED_MR_score !== "" ? this.GED_MR_score : null,
            GED_SCI_SCORE:
              this.GED_SCI_score !== "" ? this.GED_SCI_score : null,
            GED_SS_SCORE: this.GED_SS_score !== "" ? this.GED_SS_score : null,
            GED_TEST_DATE: this.GED_testDate !== "" ? this.GED_testDate : null,

            SAT_1_MATH_SCORE:
              this.SAT1_math_score !== "" ? this.SAT1_math_score : null,
            SAT_1_RW_SCORE:
              this.SAT1_readingWriting_score !== ""
                ? this.SAT1_readingWriting_score
                : null,
            SAT_1_TOTAL_SCORE:
              this.SAT1_total_score !== "" ? this.SAT1_total_score : null,
            SAT_1_TEST_DATE:
              this.SAT1_testDate !== "" ? this.SAT1_testDate : null,

            OLD_SAT_VERBAL_SCORE:
              this.OLD_SAT_verbal !== "" ? this.OLD_SAT_verbal : null,
            OLD_SAT_MATH_SCORE:
              this.OLD_SAT_math !== "" ? this.OLD_SAT_math : null,
            OLD_SAT_WRITING_SCORE:
              this.OLD_SAT_writing !== "" ? this.OLD_SAT_writing : null,
            OLD_SAT_TEST_DATE:
              this.OLD_SAT_testDate !== "" ? this.OLD_SAT_testDate : null,

            SAT_2_BIO_SCORE:
              this.SAT2_biology !== "" ? this.SAT2_biology : null,
            SAT_2_CHEM_SCORE:
              this.SAT2_chemistry !== "" ? this.SAT2_chemistry : null,
            SAT_2_PHY_SCORE:
              this.SAT2_physics !== "" ? this.SAT2_physics : null,
            SAT_2_MATH_SCORE: this.SAT2_math !== "" ? this.SAT2_math : null,
            SAT_2_TEST_DATE:
              this.SAT2_testDate !== "" ? this.SAT2_testDate : null,

            ACT_SCORE: this.ACT_score !== "" ? this.ACT_score : null,
            ACT_TEST_DATE: this.ACT_testDate !== "" ? this.ACT_testDate : null,
            IB_SCORE: this.IB_score !== "" ? this.IB_score : null,
            IB_TEST_DATE: this.IB_testDate !== "" ? this.IB_testDate : null,

            GAT_1_SCORE: this.GAT1_score !== "" ? this.GAT1_score : null,
            GAT_2_SCORE: this.GAT2_score !== "" ? this.GAT2_score : null,
            GAT_TEST_DATE: this.GAT_testDate !== "" ? this.GAT_testDate : null,
            PAT_1_SCORE: this.PAT1_score !== "" ? this.PAT1_score : null,
            PAT_3_SCORE: this.PAT3_score !== "" ? this.PAT3_score : null,
            PAT_TEST_DATE: this.PAT_testDate !== "" ? this.PAT_testDate : null,

            TOFEL_SCORE: this.TOEFL_score !== "" ? this.TOEFL_score : null,
            TOFEL_TEST_DATE:
              this.TOEFL_testDate !== "" ? this.TOEFL_testDate : null,
            IELTS_SCORE: this.IELTS_score !== "" ? this.IELTS_score : null,
            IELTS_TEST_DATE:
              this.IELTS_testDate !== "" ? this.IELTS_testDate : null,
            KMITL_TEP_SCORE:
              this.KMITL_TEP_score !== "" ? this.KMITL_TEP_score : null,
            KMITL_TEP_TEST_DATE:
              this.KMITL_TEP_testDate !== "" ? this.KMITL_TEP_testDate : null,
            OTHER_NAME: this.OTHER_name !== "" ? this.OTHER_name : null,
            OTHER_SCORE: this.OTHER_score !== "" ? this.OTHER_score : null,
            OTHER_TEST_DATE:
              this.OTHER_testDate !== "" ? this.OTHER_testDate : null,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
<style scoped>
.title1 {
  color: purple;
  /* text-decoration: underline; */
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.title2 {
  font-size: 20px;
  margin-bottom: 20px;
  text-decoration: underline;
}
</style>
